import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroupText,
  InputGroupAddon,
  Card, CardBody,
  FormGroup,
  Spinner,
  Tooltip,
  CustomInput
} from 'reactstrap';

import ReviewVoucher from './ReviewVoucher';
// import ShowVoucherView from './ShowVoucherView';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import PromosImagesForm from './PromosImagesForm';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import {
  gAPI_Vouchers_By_Id, gAPI_Amadues_Rooms, API_Xola,
  gAPI_QuestionOptionList, gAPI_Internal_Property_By_Id
} from '../../../../../../../constants/APIs';
import CatgeoryData from '../../../../../../../data/voucherCategory.json';
import searchTagsData from '../../../../../../../data/vocuherSearchTags.json';
import CustomSelectInput from '../../../../../../../components/common/CustomSelectInput';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageGallery from '../../../../propinfo/gallery/index';
import InviteVoucher from './InviteVoucher';
import ImageData from '../../../../../../../data/imageData.json';
import vouchers from '../..';


function AdsForm({
  visible,
  toggle,
  formLabel,
  submit, reportingTagData,
  updateVoucherData, xolaIntegration,
  id, isHostedPageIntegration,
  propertyId, groupId, thirdPartyVoucher,
  handleReject, email, amadeus,
  locale, ShowInviteVoucher,
  handleUpdate, invitationId,
  processingFee, approvalStatus
}) {
  const [membershipTags, setMembershipTags] = useState([]);
  const [isShowMembership, setIsShowMembership] = useState(false);
  const [selectedMemberShipTags, setSelectedMembershipTags] = useState([]);
  const [addMemberShipModal, setAddMemberShipModal] = useState(false);
  const [roomlst, setRooms] = useState([]);
  const [isActive, setisActive] = useState(false);
  const [propertyData, setPropertyData] = useState({
    bmbVoucherProcessingFee: 0
  });
  const [issearchTag, setSearchTag] = useState(false);
  const [selectedOption, setSelectedOption] = useState(''
  );
  const [ToolTip, setToolTip] = useState(false);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [imageIndex, setImageIndex] = useState(-1);
  const [error, seterror] = useState(false);
  const [addTagModel, setAddTagModel] = useState(false);
  const [ownTag, setOwnTag] = useState('');
  const [showReviewVoucher, setShowReviewVoucher] = useState(false);
  const [showReviewVoucherList, setShowReviewVoucherList] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showselect, setshowselect] = useState(true);
  const [couponList, setCouponList] = useState([]);
  const [customImages, setCustomImages] = useState([]);
  let [voucherData, setVoucherData] = useState(
    updateVoucherData || {
      groupId: getGroupID(),
      propertyId: propertyId,
      title: '',
      subTitle: '',
      actionText: '',
      link: '',
      isAd: true,
      isAds: true,
      isAmountPerDay: false,
      isAmountPerClicks: false,
      isAmountImperssion: false,
      amountPerDay: 0.00,
      amountPerClicks: 0.00,
      impressionAmount: 0.00,
      status: 'Draft',
      advertiser:'',
      advertiserEmail:'',
      startDate: moment().format('YYYY-MM-DD'),
      expiryDate: moment().add(30, 'days').format('YYYY-MM-DD'),
      creator: 'Admin',
      searchTags: [],
      images: [],
      membershipTags: [],
      options: false,
    }
  );
  let [selecedAmount, setSelectedAmount] = useState([]);
  const [reportingTags, setReportingTags] = useState([]);
  const [selectedReportingTags, setSelectedReportingTags] = useState([]);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    if (id !== undefined) {
      setisActive(true);
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Vouchers_By_Id}/${id}`,
      }).then((res) => {
        setVoucherData(res.data);
        if(res.data.adTemplate !== undefined)
          setSelectedOption(res.data.adTemplate);
        if (res.data.propertyId === propertyId) {
          loadProperty(res.data.propertyId, groupId === undefined ? getGroupID() : groupId);
        } else {
          loadProperty(res.data.propertyId, groupId === undefined ? getGroupID() : groupId);
        }
        let reportingOptions = [];
        let selectedOptions = [];
        let options=[];
        if (res.data.reportingTags !== undefined) {
          res.data.reportingTags.map((item) => {
            if (reportingOptions.filter(m => m.value === item).length === 0) {
              reportingOptions.push({
                label: item,
                value: item,
                key: item
              });
              selectedOptions.push({
                label: item,
                value: item,
                key: item
              });
            }
          });

        }
        let membershipOptions = [];
        let selectedMemberShip = [];
        if (res.data.membershipTags !== undefined) {
          res.data.membershipTags.map((item) => {
            if (membershipOptions.filter(m => m.value === item).length === 0) {
              membershipOptions.push({
                label: item,
                value: item,
                key: item
              });
              selectedMemberShip.push({
                label: item,
                value: item,
                key: item
              });
            }
          });
        }
        selectedOptions = selectedOptions.filter((f) => f.value !== 'Add own tag');
        setSelectedReportingTags(selectedOptions);
        reportingOptions.push({
          label: 'Add own tag',
          value: 'Add own tag',
          key: 'Add own tag',
        });      
        setReportingTags(reportingOptions);
        selectedMemberShip = selectedMemberShip.filter((f) => f.value !== 'Add membership');        
        membershipOptions.push({
          label: 'Add membership',
          value: 'Add membership',
          key: 'Add membership',
        });

        setMembershipTags(membershipOptions);    
        setSelectedMembershipTags(selectedMemberShip);            
        if (reportingTagData !== undefined && reportingTagData.length > 0) {
          reportingTagData.map((m) =>
            reportingOptions.push({
              label: m,
              value: m,
              key: m
            }))
        }
        
        setReportingTags(reportingOptions);
        options.push({
          label: 'Add own tag',
          value: 'Add own tag',
          key: 'Add own tag',
        });
        searchTagsData.data.map((m) => {
          options.push({
            label: m.name,
            value: m.value,
            key: m.value
          });
        });
        setTags(options); 
        try {
          res.data.searchTags.map((item) => {
            if(searchTagsData.data.filter(m => m.value === item).length === 0)
              options.push({
                label: item,
                value: item,
                key: item
              });
          }
          );
        } finally {
        }
        setTags(options);
        var selectedTags = [];
        try {
          res.data.searchTags.map((item) =>
            selectedTags.push(options.filter((cat) => cat.value === item)[0])
          );
        } finally {
        }
        setselectedTags(selectedTags); 
      });
      //.catch((err) => console.log('err', err));
    } else {
      let reportingOptions = [];
      reportingOptions.push({
        label: 'Add own tag',
        value: 'Add own tag',
        key: 'Add own tag',
      });
      if (reportingTagData !== undefined && reportingTagData.length > 0) {
        reportingTagData.map((m) =>
          reportingOptions.push({
            label: m,
            value: m,
            key: m
          }))
      }
      setReportingTags(reportingOptions);

      var options = [];
      try {
        options.push({
          label: 'Add own tag',
          value: 'Add own tag',
          key: 'Add own tag',
        });
        // res.data.map((item) =>
        //   options.push({
        //     label: item.option,
        //     value: item.option,
        //     key: item.id,
        //   })
        // );    
        searchTagsData.data.map((m) => {
          options.push({
            label: m.name,
            value: m.value,
            key: m.value
          });
        });
        setTags(options);
      } finally {
      }
      loadProperty(propertyId, groupId === undefined ? getGroupID() : groupId);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Vouchers`,
      }).then((res) => {
        if (res.data.length > 0) {
          var options = [];
          try {
            options.push({
              label: 'Add own tag',
              value: 'Add own tag',
              key: 'Add own tag',
            });
            res.data.map((item) =>
              options.push({
                label: item.option,
                value: item.option,
                key: item.id,
              })
            );
            searchTagsData.data.map((m) => {
              options.push({
                label: m.name,
                value: m.value,
                key: m.value
              });
            });
            setTags(options);
          } finally {
          }

        }


      });
      //.catch((err) => console.log('err', err));
    }
  }, [id]);

  const handleMemberShipTags = (selectedTags) => {    
    if (selectedTags.filter((elem) => elem.value === 'Add membership').length === 0) {
      setSelectedMembershipTags(selectedTags);
      const tagsArr = selectedTags.map((elem) => elem.value);
      setVoucherData({
        ...voucherData,
        membershipTags: tagsArr,
      });
    } else {
      setshowselect(false);
      setSearchTag(false);
      setAddMemberShipModal(!addMemberShipModal);
    }
  };

  const AddMemberShipTags = (val) => {    
    let tag = membershipTags;
    tag.push({ label: val, value: val, key: val });
    let tag1 = selectedMemberShipTags;
    tag1.push({ label: val, value: val, key: val });
    setMembershipTags(tag);
    setSelectedMembershipTags(tag1);
    setAddMemberShipModal(!addMemberShipModal);
    setOwnTag('');
    const tagsArr = tag1.map((elem) => elem.value);
    setVoucherData({
      ...voucherData,
      membershipTags: tagsArr,
    });
    setshowselect(true);
  }


  const loadProperty = (propertyId, group_id) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${group_id}`,
    })
      .then((res) => {
        setPropertyData(res.data);
      })
  };
  const close_clicked = () => {
    setShowReviewVoucher(!showReviewVoucher);
  }
  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  const handleChangeNameArr = (e) => {
    if (voucherData.name.length > 0) {
      const index = voucherData.name.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          name: [...voucherData.name, newStatement],
        });
      } else {
        let newArr = [...voucherData.name];
        newArr[index].statement = e.target.value;
        setVoucherData({
          ...voucherData,
          name: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setVoucherData({
        ...voucherData,
        name: [...voucherData.name, newStatement],
      });
    }
  };
  const togglegallery = (index) => {
    setImageIndex(index);
    setGalleryVisible(!galleryVisible);
  };

  const selectedImage = (image) => {
    const newItems = [...voucherData.images];
    newItems.push({ url: image.src, width: parseInt(image.width), height: parseInt(image.height) });
    setVoucherData({
      ...voucherData,
      images: newItems,
    });
    setCustomImages(newItems);
  };

  const handleOwntag=(val)=>{   
    if(issearchTag ===true){
     let tag=tags;
     tag.push({label:val,value:val,key:val});          
     let tag1=selectedTags;
     tag1.push({label:val,value:val,key:val});
     setTags(tag);
     setselectedTags(tag1);
     setAddTagModel(!addTagModel);
     setOwnTag(''); 
     const tagsArr = tag1.map((elem) => elem.value);
     setVoucherData({
       ...voucherData,
       searchTags: tagsArr,
     });
    }else{
      let tag=reportingTags;
      tag.push({label:val,value:val,key:val});          
      let tag1=selectedReportingTags;
      tag1.push({label:val,value:val,key:val});
      setReportingTags(tag);
      setSelectedReportingTags(tag1);
      setAddTagModel(!addTagModel);
      setOwnTag(''); 
      const tagsArr = tag1.map((elem) => elem.value);
      setVoucherData({
        ...voucherData,
        reportingTags: tagsArr,
      });
    }
     setshowselect(true);           
  }


  const handleChangeIntroductionArr = (e) => {
    if (voucherData.introduction.length > 0) {
      const index = voucherData.introduction.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          introduction: [...voucherData.introduction, newStatement],
        });
      } else {
        let newArr = [...voucherData.introduction];
        newArr[index].statement = e.target.value;
        setVoucherData({
          ...voucherData,
          introduction: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setVoucherData({
        ...voucherData,
        introduction: [...voucherData.introduction, newStatement],
      });
    }
  };

  const handleChangeDetailsArr = (source, e) => {
    if (source === 'user') {
      if (voucherData.details.length > 0) {
        const index = voucherData.details.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setVoucherData({
            ...voucherData,
            details: [...voucherData.details, newStatement],
          });
        } else {
          let newArr = [...voucherData.details];
          newArr[index].statement = e;
          setVoucherData({
            ...voucherData,
            details: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          details: [...voucherData.details, newStatement],
        });
      }
    }
  };

  const handleChangeConditionsArr = (source, e) => {
    if (source === 'user') {
      if (voucherData.conditions.length > 0) {
        const index = voucherData.conditions.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setVoucherData({
            ...voucherData,
            conditions: [...voucherData.conditions, newStatement],
          });
        } else {
          let newArr = [...voucherData.conditions];
          newArr[index].statement = e;
          setVoucherData({
            ...voucherData,
            conditions: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          conditions: [...voucherData.conditions, newStatement],
        });
      }
    }
  };


  const handleChangeTags = (selectedTags) => {
    if (selectedTags.filter((elem) => elem.value === 'Add own tag').length === 0) {
      setselectedTags(selectedTags);
      const tagsArr = selectedTags.map((elem) => elem.value);

      setVoucherData({
        ...voucherData,
        searchTags: tagsArr,
      });
    } else {
      setshowselect(false);
      setSearchTag(true);
      setAddTagModel(!addTagModel);
    }
  };
  const handleChange = (e) => {

    setVoucherData({
      ...voucherData,
      [e.target.name]: e.target.value,
    });

  };

  const handleSubmit = () => {
    // if (voucherData.name[0].statement === '' || voucherData.introduction[0].statement === '' ||
    //   voucherData.conditions[0].statement === '' || voucherData.details[0].statement === '' ||
    //   voucherData.totalPurchaseLimit === 0 || voucherData.orderPurchaseLimit === 0 || voucherData.price === 0 ||
    //   voucherData.instruction[0].statement === '' || voucherData.instruction[0].statement === '<p><br></p>' ||
    //   voucherData.introduction[0].statement === '<p><br></p>' || voucherData.introduction[0].statement === '<p><br></p>' ||
    //   voucherData.conditions[0].statement === '<p><br></p>' || voucherData.name[0].statement === '<p><br></p>' || voucherData.taxAmount === '' || (voucherData.taxIncluded === '' && voucherData.taxIncluded !== false)
    // ) {
    //   seterror(true);
    //   voucherData.status = 'Draft';
    // }
    // else {
    if (selectedOption === 0 || selectedOption === 1) {
      if (voucherData.title === '' || voucherData.subTitle === '') {
        seterror(true);
        voucherData.status = 'Draft';
      } else {
        voucherData.adTemplate = selectedOption;
        submit(voucherData);
      }
    }
    //  }
  };

  const handleImageChange = (e, index) => {
    e.persist();
    const newItems = [...voucherData.images];
    newItems[index][e.target.name] = e.target.value;
    setVoucherData({
      ...voucherData,
      images: newItems,
    });
  };



  const deleteImage = (index) => {
    const values = [...voucherData.images];
    values.splice(index, 1);
    setVoucherData({ ...voucherData, images: values });
  };

  const toggleToolTip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image

                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleReportingTags = (selectedTags) => {
    if (selectedTags.filter((elem) => elem.value === 'Add own tag').length === 0) {
      setSelectedReportingTags(selectedTags);
      const tagsArr = selectedTags.map((elem) => elem.value);
      setVoucherData({
        ...voucherData,
        reportingTags: tagsArr,
      });
    } else {
      setshowselect(false);
      setSearchTag(false);
      setAddTagModel(!addTagModel);
    }
  };

  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggle}
        size="lg"
        style={{ maxWidth: '1000px' }}
      >
        <ModalHeader toggle={toggle}>
          <div class="row mt-1 text-left" style={{ width: '900px' }}>
            <div className='col-md-6 mt-2'>
              {formLabel}
            </div>          
          </div>
        </ModalHeader>
        <ModalBody>

          <Row className="mb-4">
            <Colxx xxs="12">
              <Row>
                <Colxx sm={6} className="mb-3">
                  <CustomInput
                    type="checkbox"
                    id="selectedOptionFirst"
                    checked={selectedOption === 0 ? true : false}
                    name="selectedOptionFirst"
                    onChange={() => setSelectedOption(0)}
                  >Text</CustomInput>
                  {selectedOption === 0 && <Card className="mt-2" style={{ width: '60%', borderRadius: '20px' }}>
                    <CardBody>
                    <h4>{voucherData.title === '' ? "Your Advert Title" :voucherData.title}</h4>
                      {/* <p>You can hire a nanny anytime at a short notice. We will love to support you 
                        have a great time while we look after you little one 
                       </p>*/}
                      <p className='ml-2'>{voucherData.subTitle === '' ? "Subtitle about the Advert" :voucherData.subTitle}</p>                      
                      <div className="row mt-3 mb-2">
                        <div className='col-12'>
                          <a onClick={() => window.location.href = voucherData.link === ''?"http://getaiva.com/": voucherData.link}>
                          <span style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }} >{voucherData.actionText === '' ?"Get one now":voucherData.actionText}</span></a>
                        </div>
                      </div>
                    </CardBody>
                  </Card>}
                </Colxx>

                <Colxx sm={6} className="mb-3">
                  <CustomInput
                    type="checkbox"
                    id="selectedOptionSecond"
                    checked={selectedOption === 1 ? true : false}
                    name="selectedOptionSecond"
                    onChange={() => setSelectedOption(1)}>
                    Text + Image
                  </CustomInput>
                  {selectedOption === 1 && <Card className="mt-2" style={{ width: '60%', borderRadius: '20px' }}>
                    <CardBody>
                      <h4>{voucherData.title === '' ? "Your Advert Title" :voucherData.title}</h4>
                      {/* <p>You can hire a nanny anytime at a short notice. We will love to support you 
                        have a great time while we look after you little one 
                       </p>*/}
                      <p className='ml-2'>{voucherData.subTitle === '' ? "Subtitle about the Advert" :voucherData.subTitle}</p>

                      <img src={voucherData.images.length > 0 ? voucherData.images[0].url:"https://via.placeholder.com/250x150"} style={{ width: '100%', height: '10rem' }}></img>
                      <div className="row mt-3 mb-2">
                        <div className='col-12'>
                          <a onClick={() => window.location.href = voucherData.link === ''?"http://getaiva.com/": voucherData.link}>
                          <span style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }} >{voucherData.actionText === '' ?"Get one now":voucherData.actionText}</span></a>
                        </div>
                      </div>


                    </CardBody>
                  </Card>}
                </Colxx>

              </Row>
              {(selectedOption === 0 || selectedOption === 1) && <Row className="mb-2">
                <Colxx sm={6} className="mb-3">
                  <Label>Title<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="textarea"
                    maxLength={50}
                    value={(voucherData.title)}
                    onChange={handleChange}
                    name="title"
                    style={{ height: '50px' }}
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>SubTitle<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="textarea"
                    maxLength={selectedOption === 1 ? 50:125}
                    value={(voucherData.subTitle)}
                    onChange={handleChange}
                    name="subTitle"
                    style={{ height: '50px' }}
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Action Text<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="textarea" 
                    maxLength={50}                   
                    value={(voucherData.actionText)}
                    onChange={handleChange}
                    name="actionText"
                    style={{ height: '50px' }}
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Link<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="textarea"                    
                    value={(voucherData.link)}
                    onChange={handleChange}
                    name="link"
                    style={{ height: '50px' }}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Start Date<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    required
                    type="date"
                    name="startDate"
                    value={moment(voucherData.startDate).format('YYYY-MM-DD')}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Expiry Date<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    required
                    type="date"
                    name="expiryDate"
                    value={moment(voucherData.expiryDate).format('YYYY-MM-DD')}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Status<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="select"
                    value={voucherData.status}
                    name="status"
                    onChange={handleChange}
                  >
                    <option value="ActiveMembers">Active - Members Only</option>
                    <option value="Draft">Draft</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Archived">Archived</option>
                  </Input>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Primary Business Category<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="select"
                    value={
                      voucherData.category === undefined || null
                        ? 'Wine'
                        : voucherData.category
                    }
                    name="category"
                    onChange={(f) => {
                      setVoucherData({
                        ...voucherData,
                        category: f.target.value,
                      });
                    }}
                  >
                    {CatgeoryData.data !== undefined &&
                      CatgeoryData.data.map((m) => {
                        return <option value={m.value}>{m.name}</option>;
                      })}
                  </Input>
                </Colxx>
                {showselect === true && <Colxx sm={6}>
                  <FormGroup>
                    <Label for="bookingUrl">Customer Search Tags</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedTags}
                      onChange={handleChangeTags}
                      options={tags}
                    />
                  </FormGroup>
                </Colxx>}

                {showselect === true && <Colxx sm={6}>
                  <FormGroup>
                    <Label for="bookingUrl">Internal Reporting Tags</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedReportingTags}
                      onChange={handleReportingTags}
                      options={reportingTags}
                    />
                  </FormGroup>
                </Colxx>}
                <Colxx sm={6} className="mb-3">
                  <Label>Advertiser Name<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="text"                    
                    value={(voucherData.advertiser)}
                    onChange={handleChange}
                    name="advertiser"                    
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Advertiser Email<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="text"                    
                    value={(voucherData.advertiserEmail)}
                    onChange={handleChange}
                    name="advertiserEmail"                    
                  />
                </Colxx>
                
                <Colxx sm={3} className="mb-3">
                  <Label for="displayOrder">Display Order</Label>
                  <Input
                    type="number"
                    name="displayOrder"
                    min={0}
                    value={voucherData.displayOrder}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Members Only</Label>
                  <CustomInput
                    type="checkbox"
                    id="isMemberShip"
                    checked={voucherData.isMemberShip}
                    name="isMemberShip"
                    onChange={(e) => setVoucherData({
                      ...voucherData, isMemberShip: e.target.checked
                    })}
                  />
                </Colxx>
                {voucherData.isMemberShip === true && showselect === true && <Colxx sm={6}>
                  <FormGroup>
                    <Label for="bookingUrl">Memberships</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedMemberShipTags}
                      onChange={handleMemberShipTags}
                      options={membershipTags}
                    />
                  </FormGroup>
                </Colxx>}

              </Row>}


              {voucherData.images.length > 0 && <Row className="mb-2">
                <Colxx sm={12}>
                  <h4>Images</h4>
                </Colxx>
                <Colxx sm={12}>
                  {voucherData.images.map((image, index) => (
                    <Row key={`${image}~${index}`}>
                      <Colxx sm={2} className="md-3">
                        <img
                          style={{
                            width: '100%',
                            height: '90%',
                          }}
                          alt="room image"
                          src={
                            image.url || 'https://via.placeholder.com/150/'
                          }
                        />
                      </Colxx>

                      <Colxx sm={3} className="mb-3">
                        <Label>Image Display Order</Label>
                        <Input
                          type="number"
                          name="displayOrder"
                          min={1}
                          value={image.displayOrder}
                          onChange={(event) =>
                            handleImageChange(event, index)
                          }
                        />
                      </Colxx>
                      <Colxx sm={1} className="mb-3">
                        <Label>Browse</Label>
                        <div
                          className="iconsminds-photo"
                          onClick={(event) => togglegallery(index)}
                          style={{
                            cursor: 'pointer',
                            fontSize: '28px',
                            color: '#73236b',
                          }}
                        ></div>
                      </Colxx>
                      <Colxx sm={1} className="mb-3">
                        <Label>Remove</Label>
                        <div>
                          <Button
                            onClick={() => deleteImage(index)}
                            color="secondary"
                            size="xs"
                            outline
                            style={{ margin: '6px' }}
                          >
                            -
                          </Button>
                        </div>
                      </Colxx>
                    </Row>
                  ))}
                </Colxx>
              </Row>}

              {voucherData.images.length === 0 && selectedOption === 1 && <Row>
                <Colxx sm={12}>
                  <h4></h4>
                </Colxx>
                <Colxx sm={3} className="mb-2">
                  <Button
                    onClick={(event) => togglegallery(customImages.length)}
                    color="secondary"
                    size="xs"
                    outline
                    style={{ margin: '6px' }}
                  >
                    + Add Images
                  </Button>
                </Colxx>
              </Row>}
              <Row className="mb-2">

              </Row>
            </Colxx>
            </Row>
            <Row className="mb-2">
            {(selectedOption === 0 || selectedOption === 1) && <Fragment>

              <Colxx sm={12}>
                <h4>Advertising Charges<span id="info" className='ml-2'><i style={{color:'blue'}} className='iconsminds-information'></i></span></h4>
                <Tooltip
                placement="right"
                isOpen={tooltipOpen}
                target="info"
                toggle={toggleToolTip}
              >
                These are the charges you charge the advertiser, they could be fixed amount, by impressions, or by clicks. You can apply one or all of them.
              </Tooltip>
             </Colxx>
              <Colxx sm={3} className="mb-2">
                <Label>Fixed Per Day</Label>
                <CustomInput
                  type="checkbox"
                  id="isAmountPerDay"
                  checked={voucherData.isAmountPerDay}
                  name="isAmountPerDay"
                  onChange={(e) => setVoucherData({
                    ...voucherData, isAmountPerDay: e.target.checked
                  })}
                />
              </Colxx>
              {voucherData.isAmountPerDay !== false && <Colxx sm={3} className="mb-3">
                <Label for="displayOrder">Amount per day</Label>
                <Input
                  type="number"
                  name="amountPerDay"
                  min={0}
                  value={voucherData.amountPerDay}
                  onChange={handleChange}
                />
              </Colxx>}
            </Fragment>}
          </Row>

          {(selectedOption === 0 || selectedOption === 1) && <Fragment> <Row className="mb-2">
            <Colxx sm={3} className="mb-2">
              <Label>By impressions</Label>
              <CustomInput
                type="checkbox"
                id="isAmountImperssion"
                checked={voucherData.isAmountImperssion}
                name="isAmountImperssion"
                onChange={(e) => setVoucherData({
                  ...voucherData, isAmountImperssion: e.target.checked
                })}
              />
            </Colxx>
            {voucherData.isAmountImperssion !== false &&
              <Colxx sm={3} >
                <Label for="displayOrder">Amount by impressions</Label>
                <Input
                  type="number"
                  name="impressionAmount"
                  min={0}
                  value={voucherData.impressionAmount}
                  onChange={handleChange}
                />
              </Colxx>}
          </Row>
            <Row className="mb-2">
              <Colxx sm={3} className="mb-3">
                <Label>By clicks</Label>
                <CustomInput
                  type="checkbox"
                  id="isAmountPerClicks"
                  checked={voucherData.isAmountPerClicks}
                  name="isAmountPerClicks"
                  onChange={(e) => setVoucherData({
                    ...voucherData, isAmountPerClicks: e.target.checked
                  })}
                />
              </Colxx>
              {voucherData.isAmountPerClicks !== false && <Colxx sm={3} className="mb-3">
                <Label for="displayOrder">Amount per click</Label>
                <Input
                  type="number"
                  name="amountPerClicks"
                  min={0}
                  value={voucherData.amountPerClicks}
                  onChange={handleChange}
                />
              </Colxx>}
            </Row> </Fragment>}


          {isLoading && showReviewVoucherList &&
            <Spinner style={{ color: '#EF4A81' }} className="mb-1 preview-spinner" />
          }
        </ModalBody>
        <ModalFooter>        
                            
       

              {voucherData.propertyId === propertyId && <Button color="primary" onClick={handleSubmit}>
                Save
              </Button>}
            
          
          

          <Button color="secondary" onClick={() => { toggle();}}>
            Close
          </Button>
        </ModalFooter>
      </Modal >
      {ImageGalleryButton()}
      <Modal isOpen={error} toggle={() => seterror(!error)
      }>
        <ModalHeader toggle={() => seterror(!error)}>
          Voucher
        </ModalHeader>
        <ModalBody>
          <p className="m-auto">
            The Voucher has been saved as draft as some of the mandatory information is missing.
            Please complete and make the Voucher Active when ready
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { seterror(!error); submit(voucherData); }}>
            Close
          </Button>
        </ModalFooter>
      </Modal >
      <Modal isOpen={addTagModel} toggle={() => { setshowselect(true); setAddTagModel(!addTagModel); }}>
        <ModalHeader toggle={() => setAddTagModel(!addTagModel)}>
          ADD OWN {issearchTag === true ? "SEARCH" : "REPORTING"} TAG
        </ModalHeader>
        <ModalBody>
          <div className='margin-0'>
            <Input
              type="text"
              name="ownTag"
              value={ownTag}
              onChange={(e) => { setOwnTag(e.target.value) }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleOwntag(ownTag)}>
            Add
          </Button>
          <Button color="secondary" onClick={() => { setshowselect(true); setAddTagModel(!addTagModel); }}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={addMemberShipModal} toggle={() => { setshowselect(true); setAddMemberShipModal(!addMemberShipModal); }}>
        <ModalHeader toggle={() => setAddMemberShipModal(!addMemberShipModal)}>
          ADD OWN MEMBERSHIP
        </ModalHeader>
        <ModalBody>
          <div className='margin-0'>
            <Input
              type="text"
              name="ownTag"
              value={ownTag}
              onChange={(e) => { setOwnTag(e.target.value) }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => AddMemberShipTags(ownTag)}>
            Add
          </Button>
          <Button color="secondary" onClick={() => { setshowselect(true); setAddMemberShipModal(!addMemberShipModal); }}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment >
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};
export default injectIntl(connect(mapStateToProps)(AdsForm));
